export const locale = {
    lang: 'tr',
    data: {
      'ALERTS':{
        'OK':'Tamam'
      },
      'SHEDULE': {
        'TITLE1': 'Başlatma tarihini ayarla',
        'TITLE2': 'Hatırlatma tarihini ayarla',
        'TITLE3': 'Kayıt ol yakın',
        'ERR01':'Hatırlatıcılar lansman gününden daha küçük olamaz',
        'ERR02':'Hatırlatıcılar yakın günden daha büyük olamaz',
        'ERR03':'Hatırlatmalar, anket sırasında',
        'ERR04':'Yalnızca 3 hatırlatıcınız olabilir',
        'ERR05':'The date can not be lower than now',
        'ERR06':'Bugün zaten bir e-posta gönderdiniz',
        'SUC01':'Hatırlatma kaydetme',
        'SELECT_DATE': 'Bir tarih seçin',
        'SAVE': 'Kayıt etmek ',
        'RECORDATORIOS': 'Hatırlatmalar',
        'RECORDATORIO': 'Hatırlatma ', // Campo nuevo
        'ERRORDATE':'Tarih şimdi bundan önce olamaz', // Campo nuevo
        'SAMEDATE':'Anketin başlangıç tarihi olarak geçerli tarihin seçilmesine izin verilmiyor',

        'LESSDAYS_T':'Devam etmek istediğinizden emin misiniz?',
        'LESSDAYS_I':'Ortak çalışanların tam iletişim planını alabilmesi için, lansman tarihinden en az 15 gün önce anket lansman tarihini planlamanız gerekir.',
        'CONFLDATE_T':'Uyarı!',
        'CONFLDATE_I':'Devam ederseniz anket başlangıç tarihi programlamasını geri alamazsınız.',
        'WARNING_FECHA_UPDATE':'Bugünün tarihini veya bundan önce seçemezsiniz',
        'FECHA_UPDATE_WARNING':'Kapanış tarihini değiştirdiğinizden emin olun',
        'FECHA_UPDATE':'Kapanış tarihi doğru şekilde güncellendi',

        'FECHA': 'Tarih',
        'AGREGAR': 'eklemek',
        'EDITAR': 'Düzenle',
        'COMPLETAR_PASO': 'Aşamayı tamamla',
        'PASO_COMPLETADO': 'Aşama tamamlandı',
        'SUBIRLOGO': 'Anketinizi oluşturmak için şirket logonuzu yüklemeniz gerekir',
        'ACEPTARREQUERIMIENTOS': 'Anketinizi oluşturmak için teknik gereksinimleri kabul etmek gerekir',
        'LOGOSSURVEY': 'Anketinizi oluşturmak için öncelikle gerekli logoyu/logoları oluşturmanız gerekir.',
        'SELECCIONE_FECHA': 'Lütfen bir tarih seçin',
        'DATE_REGISTERED': 'Başlatma tarihi başarıyla ayarlandı',
        'CLOSE_REGISTERED': 'Kapanış Tarihi Başarıyla Tamamlandı',
        'CLOSE_MSJ1': 'kapanış tarihi çıkış tarihinden büyük olmalıdır',
        'CLOSE_MSJ2': 'Kapatılmadan önce kayıt tarihini kaydetmelisiniz',
        'REMIDEROK': 'Hatırlatıcı doğru kaydedildi',
        'REMIDERUPDAOK': 'Hatırlatıcı başarıyla güncellendi',
        'AVIUPDAOK': 'Düzgün güncellenmiş bildirim',
        'REMIDER_MSJ1': 'hatırlatıcı, yayınlanma tarihinden daha büyük olmalıdır',
        'REMIDER_MSJ2': 'Bir hatırlatıcıya kayıt olmadan önce Yayınlanma tarihini kaydetmelisiniz',

        'ENCUESTA': 'Anket',
        'CREANDO_ENCUESTA': 'Anket Yaratmak...',
        'AGREGANDO_USUARIOS': 'Kullanıcı ekleme...',
        'AGREGANDO_SECCION1': 'Ankete NPS ekleme...',
        'AGREGANDO_SECCION2': 'Ankete REAKTİFLER dding...',
        'AGREGANDO_SECCION3': 'Ankete CONTROL ekleme...',
        'AGREGANDO_SECCION4': 'Ankete DEMOGRAFİ Eklemek...',
        'AGREGANDO_SECCION5': 'Ankete EK EKLEME...',
        'AGREGANDO_SECCION6': 'Ankete FORALL ekleme...',
        'AGREGANDO_SECCION7': 'Ankete açık sorular ekleme...',
        'REINTENTAR': 'yeniden deneniyor',
        'ERROR_ENCUESTA': 'Anket oluşturulurken hata oluştu',
        'ERROR_USUARIOS': 'Kullanıcılar eklenirken hata oluştu...',
        'ERROR_SECCION1': 'NPS ankete eklenirken hata oluştu...',
        'ERROR_SECCION2': 'Ankete STATEMENTS eklenirken hata oluştu...',
        'ERROR_SECCION3': 'CONTROL anketine ekleme hatası...',
        'ERROR_SECCION4': 'DEMOGRAPHICS ankete eklenirken hata oluştu...',
        'ERROR_SECCION5': 'Ankete EK Ekleme Hatası...',
        'ERROR_SECCION6': 'FORALL anketine ekleme hatası...',
        'ERROR_SECCION7': 'açık sorular anketine ekleme hatası...',

        'SUCCESS_ENCUESTA': 'Anket başarıyla oluşturuldu!',
        'SUCCESS_USUARIOS': 'Kullanıcılar başarıyla eklendi!',
        'SUCCESS_SECCION1': 'NPS ankete başarıyla eklendi!',
        'SUCCESS_SECCION2': 'Sorular başarıyla ankete eklendi!',
        'SUCCESS_SECCION3': 'CONTROL başarıyla ankete eklendi!',
        'SUCCESS_SECCION4': 'Demografik sorular başarıyla eklendi!',
        'SUCCESS_SECCION5': 'EKLER ankete başarıyla eklendi!',
        'SUCCESS_SECCION6': 'For All başarıyla eklendi!',
        'SUCCESS_SECCION7': 'Açık sorular başarıyla eklendi!',
        'BTN_CREARENCUESTA': 'Anket oluştur',
        'CONTINUE_FINISH': 'Anket başarıyla oluşturuldu, bu adımı sonlandırabilirsiniz.',
        'LAUNCH_SURVEY': 'Lütfen adımı tamamlamak için anketi oluşturun',
      'PULSE':{
        //Shedule survey
        'MES1': ' Pulse Check ay 1',
        'MES2': ' Pulse Check ay 2',
        'MES3': ' Pulse Check ay 3',
        'MES4': ' Pulse Check ay 4',
        'MES5': ' Pulse Check ay 5',
        'MES6': ' Pulse Check ay 6',
        'MES7': ' Pulse Check ay 7',
        'MES8': ' Pulse Check ay 8',
        'MES9': ' Pulse Check ay 9',
        'MES10': ' Pulse Check ay 10',
        'MES11': ' Pulse Check ay 11',
        'MES12': ' Pulse Check ay 12',
        'INDICA': 'pulse ckeck tarihini seçin',
        'INDICA_GENERA': 'Anket Oluştur',
        'SUBINDICA_GENERA': 'Anket oluşturmak için tıklayın',

      },
    },
    'SHEDULE2_0': {
      'CARDS': {
        'PASO1': {
          'TITULO': 'Ön şartlar',
          'INFO_PRE': 'Anketi oluşturmadan önce bu önkoşulları yerine getirmeniz gerekir',
          'INFO_POST': 'Anketi oluşturmak için önkoşulları zaten yerine getirdiniz',
          'REQTEC': 'Teknik gereksinimler',
          'REQTEC_TOOLTIP': 'Teknik gereksinimlere gidin',
          'LOGO': 'Şirket logosu',
          'LOGO_TOOLTIP': 'Logoyu yüklemek için tıklayın'
        },
        'PASO2': {
          'TITULO': 'Yayın tarihi',
          'TITULO_CIERRE': 'Kapanış tarihi',
          'INFO_PRE': 'Anket için lansman tarihini seçin ve kaydedin',
          'INFO_POST': 'Seçilen tarih',
          'INFO_POST_CIERRE': 'Mevcut Kapanış Tarihi',
          'PICKDATE': 'Takvimi aç',
          'CHANGE': 'Tarihi değiştir',
          'LIS-PRORRO':' uzantılar',
        },
        'PASO2_B': {
          'TITULO': 'Tarih seçimi',
          'INFO_PRE': 'Anketi yapılandırmak için mevcut farklı tarihleri seçin ve kaydedin',
          'PICKDATE': 'Tarihleri seçin',
          'INFO_PROR': 'Bu ürüne uzantılar atandı',
          'PRORROGAS': 'Uzantıları görün',
          'TIUTLOLISTA': 'Uzantılar oluşturuldu',
          'NOPROR': 'Atanmış uzantınız yok'
        },
        'PASO3': {
          'TITULO': 'Hatırlatmalar',
          'INFO_PRE': 'Anketi cevaplamak için hatırlatma gönderme tarihleri ​​ekleyin',
          'INFO_POST': 'İki seçeneğiniz var:',
          'NUEVO': 'Yeni hatırlatıcı kaydet',
          'LISTA': 'Kayıtlı hatırlatıcılar',
          'LISTA_AVI': 'Anket öncesi iletişim',
          'TITU_AVIS':'reklamlar',
          'TIUTLOLISTA': 'Hatırlatıcılar oluşturuldu',
          'NORECOS': 'Hatırlatıcı kaydetmediniz',
          'NOAVI': 'Herhangi bir uyarı kaydetmediniz',
          'INFOHORA': 'NOT: Her hatırlatıcı kurumun yerel saatinde görüntülenir:',
          'INFOHORAAVISO': 'NOT: Her duyuru enstitünün yerel saatine göre gösterilir:',
          'TITULOLISTA': 'Bildirimler oluşturuldu',
        },
        'PASO4': {
          'TITULO': 'İletişim mesajları',
          'INFO_PRE': 'Anket yaşam döngüsü boyunca gönderilecek iletişim mesajlarını gözden geçirin',
          'VERMENSAJES': 'İletişim mesajlarına bakın'
        },
        'PASO5': {
          'TITULO': 'Anket kontrolü',
          'TITULO_ALT': 'Ana Tablo Kontrolü',
          'INFO_PRE': 'Anketin bölümlerini ve her bölüme eklenen soruların sayısını inceleyin',
          'VERMENSAJES': 'Bölüm verilerine bakın',
          'FILTRAR': 'Bölümleri ada göre filtrele',
          'TABLE':{
            'SECTION': 'Bölüm',
            'VALUE': 'Değer',
          }
        },
        'PASO6': {
          'TITULO': 'Anket Oluşturma Geçmişi',
          'INFO_PRE': 'Son anket oluşturma tarihi:',
          'INFO_PRE_2': 'Nesil geçmişi:',
        },
        'PASO7': {
          'TITULO': 'Anket özellikleri',
          'INFO_PRE': 'Anket özelliklerini yapılandırmadan önce ön koşulları tamamlamanız gerekir.',
          'INFO_POST_1': 'Anketi oluşturmadan önce anketin özelliklerini yapılandırmanız gerekir.',
          'INFO_POST_2': 'Anketi oluşturmak için gerekli ayarları zaten yaptınız',
          'EMPRESA': 'Şirket logosu',
          'CERTIFICADO': 'Sertifika logosu',
          'CARACTERISTICAS': 'Anket özellikleri',
          'PREVIEW': 'Ön izleme',
          'CAMBIAR': 'Resmi değiştir',
          'LOGO_EMP_INFO': 'Görüntü, kayıtlı çözünürlüğünde, 200x200 pikselde görüntülenir'
        },
        'MODALGEN': {
          'REGRESAR': 'Geri gitmek',
          'HISTORIAL': {
            'BOTON': 'Anket oluşturma geçmişi',
            'TITULO': 'Anket oluşturma geçmişi',
            'CARGANDO': 'Oluşturma geçmişi yükleniyor',
            'ULTIMA': 'Son nesil tarihi',
            'ANTERIORES': 'Önceki nesil tarihleri',
            'NOHISTO': 'Anketin neslinin geçmişi yok'
          },
          'CERTIFICADO': {
            'TITULO': 'Sertifika önizlemesi'
          },
          'URL_QR': {
            'BOTON': 'QR kodunda bağlantı alın',
            'TITULO': 'QR kodundaki anket bağlantısı',
            'SUBTITULO': 'Bu QR kodunu tarayarak, bağlantıyı manuel olarak girmek zorunda kalmadan ankete doğrudan erişebilirsiniz.',
            'DESCARGA': 'QR kodunu indirmek için resme sağ tıklayın ve ardından <b> <em> Resmi farklı kaydet ... </em> </b> seçeneğine tıklayın.',
            'REGENERARQR': 'URL doğru bir şekilde değiştirildi, önceki URL\'den bir QR kodunuz varsa, güncellenmiş bağlantıyla yeni bir QR kodu almanız gerekir.'
          }
        },
        'STATUS': {
          'PENDING': 'Henüz tamamlanmadı',
          'OK': 'hazır',
          'OPT': 'Bu adım isteğe bağlıdır'
        },
        'FECHAS': {
          'TITULO': 'Tarih seçimi',
          'FECHA': 'Seçilen tarih:',
          'NOTYET': 'Henüz seçilmedi',
          'INFO': {
            '1': 'Anketi yapılandırmak için mevcut tarihlerin her birini seçin.',
            '2': 'NOT: Her tarihte seçilen saat, kurumun yerel saatine göre ayarlanır:'
          },
          'TABLA': {
            'TIPO': 'Tarih türü',
            'FECHA': 'Seçilen tarih',
            'ACCIONES': 'Hareketler'
          },
          'TIPOS': {
            'lanzamiento': 'Lansman tarihi',
            'aviso1': 'Lansman öncesi (Anketin başlamasından önce ilk bildirim)',
            'aviso2': 'Lansman öncesi (Anketin başlamasından önceki ikinci bildirim)',
            'cierre': 'Son tarih',
            'recor30': 'Lansman öncesi (anketten 30 gün önce bildirim)',
            'registro29': 'Lansman öncesi (Anketten 29 gün önce haber verin)',
            'recor15': 'Lansman öncesi (anketten 15 gün önce bildirim)',
            'recor7': 'Lansman öncesi (anketten 7 gün önce bildirim)',
            'result': 'Sonuçlar:',
          },
          'BOTONES': {
            'ELEGIR': 'Tarih seçin',
            'CAMBIAR': 'Tarihi değiştir',
            'CANCELAR': 'İptal etmek',
            'ACEPTAR': 'Kabul etmek',
            'ENVIOCIERRE': 'Bildirim gönder'
          }
        }
      },
      'CREAR': 'Anket oluştur',
      'RECREAR': 'Anketi yeniden oluşturun',
      'ENCUESTACREADA': 'Anket oluşturuldu',
      'ENCUESTAERROR': 'Anket doğru şekilde oluşturulmamış',
      'VERSECCIONES': 'Eklenen bölümlere bakın',
      'BACK': 'Geri',
      'CERRAR': 'Kapat',
      'CREANDO': 'Anket oluşturuluyor, bileşenlerinin her biri doğru şekilde eklenene kadar bekleyin',
      'RETRY': 'İşlemi tekrar deneyin',
      'SECCIONES': {
        'DETALLES': 'Son ayrıntıları kaydetme',
        'COMPLETA': 'Anket başarıyla oluşturuldu!',
        'ENCUESTA': {
          'TITULO': 'anket',
          'PROCESO': 'Anket oluşturma',
          'ERROR': 'Anket oluşturulurken bir hata oluştu, lütfen işlemi tekrar deneyin'
        },
        'USUARIOS': {
          'TITULO': 'Kullanıcılar',
          'PROCESO': 'Ankete kullanıcı ekleme',
          'ERROR': 'Kullanıcılar eklenirken bir hata oluştu, işlemi tekrar deneyin',
        },
        'NPS': {
          'TITULO': 'NPS',
          'PROCESO': 'Ankete NPS ekleme',
          'ERROR': 'NPS eklenirken bir hata oluştu, lütfen işlemi tekrar deneyin',
        },
        'REACTIVOS': {
          'TITULO': 'tablolar',
          'PROCESO': 'Ankete ifade ekleme',
          'ERROR': 'İfadeler eklenirken bir hata oluştu, lütfen işlemi tekrar deneyin',
        },
        'CONTROL': {
          'TITULO': 'Kontrol sorusu',
          'PROCESO': 'Ankete kontrol sorusu ekleme',
          'ERROR': 'Kontrol sorusu eklenirken bir hata oluştu, işlemi tekrar deneyin',
        },
        'DEMOGRAFICOS': {
          'TITULO': 'Demografik',
          'PROCESO': 'Ankete demografi ekleme',
          'ERROR': 'Demografi eklenirken bir hata oluştu, lütfen işlemi tekrar deneyin',
        },
        'ABIERTAS': {
          'TITULO': 'Açık sorular',
          'PROCESO': 'Ankete açık sorular ekleme',
          'ERROR': 'Açık sorular eklenirken bir hata oluştu, lütfen işlemi tekrar deneyin',
        },
        'FORALL': {
          'TITULO': 'Hepsi için',
          'PROCESO': 'Ankete ForAll uygulamaları ekleme',
          'ERROR': 'ForAll uygulamaları eklenirken bir hata oluştu, işlemi yeniden deneyin',
        },
        'ADICIONALES': {
          'TITULO': 'Ek',
          'PROCESO': 'Ankete ek sorular ekleme',
          'ERROR': 'Başka soru eklenirken bir hata oluştu, lütfen işlemi tekrar deneyin',
        },
        'ADICIONALES-FOCUS': {
          'TITULO': 'Kişiselleştirilmiş',
          'PROCESO': 'Ankete özel sorular eklemek',
          'ERROR': 'Özel soruları eklerken bir hata oluştu, lütfen işlemi tekrar deneyin',
        },
      },
      'MODALES': {
        'ENCUESTA': {
          'CREAR_1': 'Mevcut yapılandırmayla anket oluşturmak ister misiniz?',
          'CREAR_2': 'Anket oluşturulduktan sonra iletişim mesajlarını değiştiremezsiniz',
          'CREAR_3': 'Anket oluşturmaya başlamak istiyor musunuz?',
          'SINFECHA': 'Anketi oluşturmak için önce aynı başlangıç ​​tarihini seçmek gerekir',
          'CREADA_1': 'Anket başarıyla oluşturuldu!',
          'CREADA_2': 'Artık bu bölümü tamamlayabilir ve bir sonraki bölüme devam edebilirsiniz.',
          'RECOEXIS': 'Seçilen gün için zaten kayıtlı bir hatırlatma var',
          'RECOBEFORE': 'İlk olarak anket başlangıç ​​tarihini seçmeden hatırlatıcı kaydedemezsiniz',
          'RECOMAX': 'İzin verilen tüm hatırlatıcıları zaten programladınız, artık yenilerini kaydedemezsiniz',
          'LASTRECO_1': 'Uyarı:',
          'LASTRECO_2': 'İzin verilen tüm hatırlatıcıları planladınız, artık yenilerini kaydedemeyeceksiniz',
          'LISTARECOBEF': 'Önce anket başlangıç ​​tarihini seçmeden hatırlatma listesini görüntüleyemezsiniz',
          'FINAL': 'Artık bu bölümü tamamlayabilir ve bir sonraki bölüme devam edebilirsiniz.',
          'SAVELAUNCHDATE': 'Anket başlatma tarihi kaydediliyor, lütfen biraz bekleyin',
          'SAVEAVISODATE': 'Bildirim tarihini kaydediyor, lütfen biraz bekleyin',
          'AVISOOK': 'Bildirim tarihi başarıyla kaydedildi',
          'CHANGELAUNCH': 'Uyarı: Anketin başlangıç tarihini değiştirirseniz, geri kalan tarihler silinecek ve bunları tekrar seçmeniz gerekecek, başka bir başlangıç tarihi seçmek ister misiniz?',
          'CHANGECLOSENOT': 'Bildirim gönderme durumu başarıyla değiştirildi',
          'GUARDANDO_LOGO': 'Görüntü kaydediliyor, bir dakika bekleyin',
          'CARGA_CERT': 'Nihai belgede en yüksek kaliteyi elde etmek için, minimum 400 x 240 piksel çözünürlüğe sahip bir resim yüklediğinizden emin olun.',
          'BORRA_RECO_1': 'Aşağıdaki tarihe sahip hatırlatıcıyı silmek istediğinizden emin misiniz?',
          'BORRA_RECO_2': 'Hatırlatıcı başarıyla silindi',
          'BORRA_AVI_1': 'Aşağıdaki tarihe sahip hatırlatıcıyı silmek istediğinizden emin misiniz?',
          'BORRA_AVI_2': 'Hatırlatıcı başarıyla hatırlatıldı',
          'UPDA_AVISO':'Hatırlatma tarihi güncelleniyor',
          'UPDA_RECOR':'Hatırlatma tarihi güncelleniyor',
          'DELE_AVISO':'Hatırlatma tarihi siliniyor',
          'DELE_RECOR':'Hatırlatma tarihi siliniyor',
          'GUARD_RECOR':'Hatırlatma tarihi kaydediliyor',
          'TITL_MOD_QUES_ALEAT':'Anketi oluşturmak için rastgele soru doğrulamasını etkinleştirmek gerekir.',
          'TEXT_MOD_QUES_ALEAT_1':'Ardından aşağıdaki adımları izleyin:',
          'TEXT_MOD_QUES_ALEAT_2':'1.- Anket özelliklerini düzenlemek için girin.',
          'TEXT_MOD_QUES_ALEAT_3':'2.- Ek yapılandırmaya tıklayın ve rastgele soru doğrulamasını etkinleştirin',
        }
      },
      'CORREOS': {
        'VER': 'Mesajı görün',
        'TIPO1': {
            'TITULO': 'Lansman öncesi mesajı',
            'INFO': 'Bunlar, anketin başlatılmasından günler önce gönderilen mesajlardır',
            'TIPO_1': 'İlk bildirim mesajı',
            'TIPO_2': 'İkinci bildirim mesajı',
        },
        'TIPO2': {
            'TITULO': 'Davet mesajı',
            'INFO': 'Bu, anketin başlatıldığı gün ortak çalışanlara gönderilen mesajdır'
        },
        'TIPO3': {
            'TITULO': 'Hatırlatma mesajı',
            'INFO': 'Bu, bu amaç için planlanan günlerde gönderilen hatırlatma mesajıdır.'
        },
        'TIPO4': {
            'TITULO': 'İlk bildirim mesajı',
            'INFO': ''
        },
        'TIPO5': {
            'TITULO': 'İkinci bildirim mesajı',
            'INFO': ''
        },
        'TIPO6': {
            'TITULO': 'Anket kapatma mesajı',
            'INFO': 'Bu, anketin kapanış tarihinde ortak çalışanlara gönderilen mesajdır\nNOT: yalnızca etkinleştirildiyse gönderilecektir'
        },
        'TIPO7': {
          'TITULO': 'Anketlerine başlamayan ortak çalışanlara mesaj',
          'INFO': 'Bu, anketlerine henüz başlamamış ortak çalışanlara gönderilen hatırlatma mesajıdır'
        },
        'TIPO8': {
          'TITULO': 'Henüz bitirmemiş ortak çalışanlara mesaj',
          'INFO': 'Bu, anketlerine zaten başlamış ancak henüz bitirmemiş katılımcılara gönderilen hatırlatma mesajıdır.'
        },
      },
      'EDITOR': {
        'BOTONES': {
          'INFO': 'Önemli bilgi',
          'SAVE': 'Değişiklikleri Kaydet',
          'EDIT': 'Mesajı düzenle',
        },
        'PENDING': 'Doğrulama sürecinde',
        'MODALINFO': {
          'TITULO': 'E-postanın içeriği hakkında önemli bilgiler',
          'PARTE_1': 'E-postanın gönderilmesinin doğru kabul edilmesi için aşağıdaki etiketler mesajın gövdesine eklenebilir (Dikkat, zorunlu etiketlerin en az bir kez eklenmesi gerekir):',
          'PARTE_2': 'Bunun nedeni, her e-postanın teslim tarihi geldiğinde, platformun mesajda aşağıdaki değişiklikleri otomatik olarak gerçekleştirmesidir:',
          'tag_company': 'Şirket adı',
          'tag_link': 'Ankete erişim bağlantısı',
          'tag_date': 'Anketin lansman tarihi',
          'tag_user': 'Anket erişim şifresi',
          'tag_dtb': 'Anketin başlamasına kadar geçen günler (mesajın gönderildiği tarihten itibaren)',
          'tag_dtc': 'Anketin sonuna kadar geçen günler (mesajın gönderildiği tarihten itibaren)',
          'tag_end': 'Anketin kapanış tarihi',
          'tag_userAction': 'Giriş yapılacak kullanıcı',
          'tag_pass': 'Kullanıcının şifresi',
          'tag_linkAction': 'Kültürel Go ya erişim bağlantısı',
          'PARTE_3': 'Etiketler e-postanın gövdesinin herhangi bir yerine yerleştirilebilir. Etiketler içerikte bulunduktan sonra kaydedilebilir',
          'PARTE_4': 'Not: Mesajın bir proje yöneticisi tarafından doğrulanması gerekebilir, bu durumda yeni e-postanın doğrulama durumunu bu ekranda görebileceksiniz. Doğrulama işlemi sırasında e-postanın yeni bir basımını yapamazsınız. Aksi takdirde, e-posta hemen geçerli sayılır ve isterseniz yeniden düzenleyebilirsiniz.',
          'OPC': '(İsteğe bağlı)',
          'MDT': '(Yakın mesaj dışında zorunludur)'
        },
        'MODALES': {
          'SINCAMBIOS': 'E-postanın içeriğinde henüz değişiklik yapmadınız',
          'SINTAG': 'Posta kaydedilemedi, sonraki etiket bulunamadı:',
          'GUARDAR_1': 'Mesajda yapılan değişiklikleri kaydetmek istiyor musunuz?',
          'GUARDAR_2': 'Doğrulama için gönderileceğini ve doğrulama işlemi bitene kadar yeniden düzenleyemeyeceğinizi hatırlatırız.',
          'SAVEOK_1': 'E-postanın içeriği doğru kaydedildi',
          'SAVEOK_2': 'Bir proje yöneticisinin değişiklikleri doğrulamasını bekleyin',
          'ENABLED': 'Bir proje yöneticisi e-posta düzenlemeyi yeniden etkinleştirdi, değişiklikler yapmaya devam edebilirsiniz',
          'CAMBIOIDIOMA_1': 'Uyarı: Başka bir dil seçmek istiyorsanız, şimdiye kadar mevcut dilde yapılan değişikliklerin önce kaydedilmesi gerekir',
          'CAMBIOIDIOMA_2': 'Değişiklikleri kaydetmek ve başka bir dil seçmek istiyor musunuz?',
        }
      },
      'ZONAS': {
        '1': 'Meksika şehri',
        '2': 'San Salvador',
        '3': 'Hong Kong',
        '4': 'Singapur',
        '5': 'İstanbul',
        '6': 'Manila',
        '11': 'Brezilya',
        '15': 'Madrid',
        '18': 'Meksika şehri',
      },
      'SECCIONES_ESPECIALES': {
        'TITULO': 'Bu ankette özel bölümler var',
        'SUBTITULO': 'Aşağıda demo kullanıcıları gruplandırılmış bir şekilde yer almaktadır, her grubun anketi her özel bölümle ayrı ayrı veya özel bölümleri olmayan anketi test etmesi amaçlanmıştır.',
        'ELEGIR': 'Soldaki menüden bir grup seçin',
        'LISTA': {
          'TITULO': 'özel bölümler',
          'SIN_SECCION': 'Özel bölümler olmadan anket'
        }
      },
      'CORREOS_NORM':{
        'TIPO1':{
          'TITULO': 'Lansman öncesi mesajı',
          'INFO': 'Bunlar, anketin başlatılmasından günler önce gönderilen mesajlardır',
        },
        'TIPO2':{
          'TITULO': 'Uyarı mesajı: Davetiyenin başlamasından 30 gün önce' ,
          'INFO': 'Bunlar, anketin başlamasından günler önce gönderilen mesajlardır.'
        },
        'TIPO3':{
          'TITULO': 'Uyarı mesajı: Davetiyenin başlamasından 29 gün önce',
          'INFO': 'Bunlar, anketin başlamasından günler önce gönderilen mesajlardır.'
        },
        'TIPO4':{
          'TITULO': 'Uyarı mesajı: Davetiyenin başlamasından 15 gün önce',
          'INFO': 'Bunlar, anketin başlamasından günler önce gönderilen mesajlardır.'
        },
        'TIPO5':{
          'TITULO': 'Uyarı mesajı: Davetiyenin başlamasından 7 gün önce',
          'INFO': 'Bunlar, anketin başlamasından günler önce gönderilen mesajlardır.'
        },
        'TIPO6': {
            'TITULO': 'Anket kapatma mesajı',
            'INFO': 'Bu, anketin kapanış tarihinde ortak çalışanlara gönderilen mesajdır\nNOT: yalnızca etkinleştirildiyse gönderilecektir'
        },
        'TIPO7':{
          'TITULO': 'Hatırlatma mesajı',
          'INFO': 'Bu, bu amaç için planlanan günlerde gönderilen hatırlatma mesajıdır.'
        },
      }
    }
  }
};
